/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../../core/abstractions/base.model';

export class ChangeEmailPhoneModel extends BaseModel {
    isEmailConfirmed = false;
    isPhoneConfirmed = false;
    validateEmailOnly = false;

    constructor(init?: Partial<ChangeEmailPhoneModel>) {
        super();
        Object.assign(this, init);
    }
}
